<template>
  <div id="app" @touchmove="handleTouch">
    <router-view />
  </div>
</template>

<script>
window.onload = function () {};
export default {
  created() {
    // document.addEventListener("touchstart", function (event) {
    //   if (event.touches.length > 1) {
    //     event.preventDefault();
    //   }
    // });
    // var lastTouchEnd = 0;
    // document.addEventListener(
    //   "touchend",
    //   function (event) {
    //     var now = new Date().getTime();
    //     if (now - lastTouchEnd <= 300) {
    //       event.preventDefault();
    //     }
    //     lastTouchEnd = now;
    //   },
    //   false
    // );
    // document.addEventListener("gesturestart", function (event) {
    //   event.preventDefault();
    // });
    // document.body.addEventListener(
    //   "touchmove",
    //   (e) => {
    //     if (e._isScroller) return;
    //     e.preventDefault();
    //   },
    //   {
    //     passive: false,
    //   }
    // );
  },
  mounted() {
    // plus.screen.lockOrientation("landscape-primary");
    // window.addEventListener("resize", this.resize);
  },
  methods: {
    // resize() {
    //   var width = window.innerWidth,
    //     height = window.innerHeight,
    //     $wrapper = document.getElementById("app"),
    //     style = "";
    //   if (width >= height) {
    //     // 横屏
    //     style += "width:" + width + "px;"; // 注意旋转后的宽高切换
    //     style += "height:" + height + "px;";
    //     style += "-webkit-transform: rotate(0); transform: rotate(0);";
    //     style +=
    //       "-webkit-transform-origin: " + width / 2 + "px " + width / 2 + "px;";
    //     style += "transform-origin: " + width / 2 + "px " + width / 2 + "px;";
    //   } else {
    //     // 竖屏
    //     style += "width:" + height + "px;";
    //     style += "height:" + width + "px;";
    //     style += "-webkit-transform: rotate(90deg); transform: rotate(90deg);";
    //     // 注意旋转中点的处理
    //     style +=
    //       "-webkit-transform-origin: " + width / 2 + "px " + width / 2 + "px;";
    //     style += "transform-origin: " + width / 2 + "px " + width / 2 + "px;";
    //   }
    //   $wrapper.style.cssText = style;
    // },
    handleTouch(e) {
      e._isScroller = true;
    },
  },
};
</script>
<style lang="less">
html,
body {
  width: 100vw;
  // height: 100%;
  overflow: hidden;
  margin: 0;
  -webkit-overflow-scrolling:touch;
}
#app {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.platform-menu {
  width: 150px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #282b33;
}
.platform-menu .arrow {
  color: #fff;
  line-height: 48px;
  text-align: center;
  background: #23262e;
  cursor: pointer;
}

.el-table{
  width:99.9% !important;
}
@media (max-width: 900px) and (orientation: landscape) {
  body {
    width: 100vw;
    height: 100vh;
    padding-bottom: calc(60px + constant(safe-area-inset-bottom));
    padding-bottom: calc(60px + env(safe-area-inset-bottom));
    overflow: hidden;
    margin: 0;
    box-sizing: border-box;
  }
  #app {
    width: 100vw;
    height: 100vh;
    min-width: 0;
    .pool_bd_title {
      flex-direction: column;
      justify-content: space-between;
      .pool_tab_box {
        span {
          padding: 0 16px;
        }
      }
      .el-input-group {
        margin-left: 0;
        margin-top: 10px;
      }
    }
    .pool_bd_title {
      .pool_bd_content {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        justify-content: space-between;
      }
    }
    .menu-hd {
      .hd-main {
        width: 100vw;
      }
    }
    .login-page {
      overflow-x: hidden;
      height: 100%;
      .logo-title {
        font-size: 20px;
        color: white;
        margin-bottom: 60px;
      }
      .login-form {
        margin: 0;
        box-sizing: border-box;
      }
    }
  }
}
@media (max-width: 480px) and (orientation: portrait) {
  body {
    width: 100vw;
    height: 100vh;
    padding-bottom: 60px;
    padding-bottom: calc(60px + constant(safe-area-inset-bottom));
    padding-bottom: calc(60px + env(safe-area-inset-bottom));
    overflow: hidden;
    margin: 0;
    box-sizing: border-box;
  }
  #app {
    width: 100vw;
    height: 100vh;
    min-width: 0;
    .menu-hd {
      .hd-main {
        width: 100vw;
      }
    }
    .login-page {
      overflow-x: hidden;
      .logo-title {
        font-size: 20px;
        color: white;
        margin-bottom: 60px;
      }
      .login-form {
        margin: 0;
        width: 84%;
        box-sizing: border-box;
      }
    }
  }
}

// 修复safari选择弹出框位置错乱
.el-select .el-select-dropdown {
  position: absolute !important;
  left: 0px !important;
  top: auto !important;
  z-index: 2028 !important;
}
</style>
